import type { SxProps, Theme } from '@mui/material';

import { ChevronDownIcon } from '@/components/icons/ChevronDownIcon';
import { COLORS } from '@/styles/tokens/colors';

interface SelectChevronIconProps {
  className?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export const SELECT_CHEVRON_ABSOLUTE_SX = {
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none',
} as const;

export const SELECT_CHEVRON_ICON_SX = {
  '& .MuiSelect-icon': {
    right: SELECT_CHEVRON_ABSOLUTE_SX.right,
    top: 'calc(50% - 8px)',
    color: COLORS.TEXT.SECONDARY,
    pointerEvents: 'none',
  },
  '&.Mui-disabled .MuiSelect-icon': {
    color: COLORS.TEXT.DISABLED,
  },
} as const;

export function SelectChevronIcon({
  className,
  disabled = false,
  sx,
}: SelectChevronIconProps) {
  return (
    <ChevronDownIcon
      aria-hidden
      className={className}
      color={disabled ? COLORS.TEXT.DISABLED : COLORS.TEXT.SECONDARY}
      size={16}
      sx={sx}
    />
  );
}
